import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import styled from "styled-components";
import "./main.scss";
import moment from "moment";

export default class CalendarMonth extends React.Component {
  constructor(props) {
    super(props);
    this.calendarRef = React.createRef();

    this.state = {
      selectedDates: [],
      showInfo: false,
      info: {},
      events: props.events,
      justCreated: false,
      eventId:0
    };
    this.timer = null
    
    this.handleAddDate = props.handleAddDate;
    this.handleRemoveDate = props.handleRemoveDate;

  }

  
  

  componentWillReceiveProps({ selectedDates }) {
    
    this.setState({
      selectedDates
      
    });
    
  }

  componentDidUpdate(){

  }


  hideToolTip = () => {
    this.setState({
      showInfo: false,
      info: {},
    });
  }
  handleLeaveEvent= ({ event }) => {
    clearTimeout(this.timer)
    this.setState({
      showInfo: false,
      info: {},
    });
  };

  handleMouseEnter = ({event,jsEvent}) => {
    if (event.groupId == "temp") {
      return;
    }
    this.eventClick(event,jsEvent);
  };

  handleEventClick = (clickedEvent) => {
    let { event, jsEvent } = clickedEvent;
    if (event.groupId == "temp") {
      return;
    }
    this.eventClick(event,jsEvent);
  };

  handleDateClick =(clickedDate) => {
    let calendarApi = this.calendarRef.current.getApi();
    
    if(this.state.justCreated)  return;
    
    let endClickedDate = moment(clickedDate.date).add(1,"days");
    let eventsCalendar = calendarApi.getEvents().filter((event) => {
      return event.groupId =="temp" && 
      event.start.toISOString() <= clickedDate.date.toISOString() &&
      event.end.toISOString()>= endClickedDate.toISOString()
    });
    if (eventsCalendar.length=== 1) {
      let event = eventsCalendar[0];
      if(event.start.toISOString() == clickedDate.date.toISOString() && event.end.toISOString() == endClickedDate.toISOString()) {
        this.handleRemoveDate(event);
       event.remove();
       return;
      }
      if(event.start.toISOString() == clickedDate.date.toISOString()) {
        this.createBackgroundEvent(endClickedDate,event.end);
        this.handleRemoveDate(event);
        event.remove()
        return;
      }
      if(event.end.toISOString()== endClickedDate.toISOString()) {
        this.createBackgroundEvent(event.start,clickedDate.date);
        this.handleRemoveDate(event);
        event.remove()
        return;
      }
      this.createBackgroundEvent(event.start,clickedDate.date);
      this.createBackgroundEvent(endClickedDate,event.end);
      this.handleRemoveDate(event);
      event.remove()
    }

  };

  eventClick =(event,jsEvent)=>{
    const { dayTypeName, comment } = event.extendedProps;
    clearTimeout(this.timer)
    this.setState({
      showInfo: true,
      info: {
        pageX: jsEvent.pageX,
        pageY: jsEvent.pageY,
        title: dayTypeName,
        comment: comment,
        color: event.textColor,
      },
    }); 
    this.timer = setTimeout(() => {
      this.setState({
        showInfo: false,
        info: {},
      });
    },5000)
  }

  handleDatesSelected = (datesSelected) => {
    this.setState({justCreated: false});
    
    let calendarApi = this.calendarRef.current.getApi();
    let events = calendarApi.getEvents().filter((event) => {return event.groupId =="temp"});
    if (this.checkIfDateOverlapsAnother(datesSelected,events)) {
     return;
    }
    
    if (this.checkIfDatesSelectedInsideEvent(datesSelected, events)) {
       return false;
    }
    
    if (this.checkIfDatesInBetweenEvents(datesSelected, events)) {
      return false;
    }
    
    if (this.checkIfDatesSelectedBeforeEvent(datesSelected, events)) {
      return false;
    }

    if (this.checkIfDatesSelectedNextEvent(datesSelected, events)) {
      return false;
    }
    
    this.createBackgroundEvent(datesSelected.start, datesSelected.end);
    return false;
   
  };

  checkIfDateOverlapsAnother =(datesSelected, events) => {
   
    let overlap = false;
    events.forEach((event) => {
      if (
        datesSelected.start.toISOString() >= event.start.toISOString() &&
        datesSelected.end.toISOString() <= event.end.toISOString()) {
          overlap = true;
        }
    });
    return overlap;
  };

  checkIfDatesSelectedInsideEvent = (datesSelected, events) => {
    let inside = false;
    events.forEach((event) =>{
      if(
        datesSelected.start.toISOString() >= event.start.toISOString() &&
        datesSelected.end.toISOString()<= event.end.toISOString()
        ) {
          inside = true;
        }
      });
    return inside;
  };

  checkIfDatesSelectedBeforeEvent = (datesSelected, events) => {
    let isBefore = false;
    events.forEach((event) =>{
      if(
        datesSelected.end.toISOString() === event.start.toISOString() ||
        (datesSelected.end.toISOString() < event.end.toISOString() &&
        datesSelected.start.toISOString()< event.start.toISOString() &&
        datesSelected.end.toISOString() > event.start.toISOString())
        ) {
          this.createBackgroundEvent(datesSelected.start,event.end);
          this.handleRemoveDate(event);
          event.remove()
          isBefore = true;
        }
      });
    return isBefore;
  };

  checkIfDatesSelectedNextEvent = (datesSelected, events) => {
    let isNext = false;
    events.forEach((event) =>{
      if(
        datesSelected.start.toISOString() === event.end.toISOString() ||
        (datesSelected.start.toISOString() > event.start.toISOString() &&
        datesSelected.end.toISOString() > event.end.toISOString() &&
        datesSelected.start.toISOString() < event.end.toISOString())
        ) {
          this.createBackgroundEvent(event.start,datesSelected.end);
          this.handleRemoveDate(event);
          event.remove()
          isNext = true;
        }
      });
    return isNext;
  };

  checkIfDatesInBetweenEvents = (datesSelected, events) => {
    let isInBetween =false;
    let eventBefore = events.filter((event) => {
      return event.end.toISOString() === datesSelected.start.toISOString();
    });
    let eventAfter = events.filter((event) => {
      
      return event.start.toISOString() === datesSelected.end.toISOString();
    });
    
    if(eventBefore.length ===1 && eventAfter.length ===1) {
      isInBetween = true;
      this.createBackgroundEvent(eventBefore[0].start, eventAfter[0].end);
      this.handleRemoveDate(eventBefore[0]);
      this.handleRemoveDate(eventAfter[0]);
      eventBefore[0].remove();
      eventAfter[0].remove();
    }
    
    return isInBetween;
  }

  createBackgroundEvent =(start, end) => {
    this.setState({justCreated: true});
    let calendarApi = this.calendarRef.current.getApi();
    let id = this.state.eventId+1;
    
    this.setState({eventId: id});
    
    let event = {
      title: "",
      start:  moment(start).format("yyyy-MM-DD"),
      end: moment(end).format("yyyy-MM-DD"),
      id: id,
      groupId: "temp",
      rendering: 'background',
      background:"rgba(3, 22, 59, 0.9)",//backgroundColor:"rgba(188,232,241,0.95)",
      allDay: true
    };
    

    calendarApi.addEvent(event);

    this.handleAddDate({id,start,end});
  }

  render() {
    return (
      <div className="demo-app">
        <div className="demo-app-top">&nbsp;</div>
        <div className="demo-app-calendar">
          <CalendarWrapper 
            color={"inherit"}
            headerColor={this.props.isDarkMode ? "white" : "black"}
            opacity={this.props.isDarkMode ? 0.5 : 0.3}
          >
            <FullCalendar
              defaultView="dayGridMonth"
              defaultDate={this.props.month}
              eventColor="green"
              header={{
                left: "",
                center: "title",
                right: "",
              }}
              height="auto"
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              ref={this.calendarRef}
              events={this.state.events}
              dateClick={this.handleDateClick}
              eventClick={this.handleEventClick}
              eventMouseEnter={this.handleMouseEnter}
              eventMouseLeave={this.handleLeaveEvent}
              select={this.handleDatesSelected}
              showNonCurrentDates={false}
              selectable={this.props.selectable}
              unselectAuto ={false}
              editable= {false}
              
            />
          </CalendarWrapper>
          {this.state.showInfo ? (
            <EventInfo
              top={this.state.info.pageY}
              left={this.state.info.pageX}
              color={this.state.info.color}
              onClick={this.hideToolTip}
            >
              <span className="title">{this.state.info.title}</span>
              {this.state.info.comment ? (
                <span style={{  whiteSpace: 'pre-wrap' }} className="comment">{this.state.info.comment}</span>
              ) : null}
            </EventInfo>
          ) : null}
        </div>
      </div>
    );
  }
}
// background-color: ${(props) => props.color};
const CalendarWrapper = styled.div`
  // background-color: #f8f8f8;

  & th.fc-day-header > span,
  th.fc-day-header,
  .fc-center h2,
  span.fc-day-number {
    color: ${(props) => props.headerColor} !important;
  }

  & td.fc-bgevent {
    opacity: ${(props) => props.opacity};
  }
  &
    td.fc-event-container
    > a.fc-event:not([style="background-color:rgba(255, 0, 0, 0);border-color:rgba(255, 0, 0, 0);color:black"])
    span.fc-title {
    color: ${(props) => props.color} !important;
  }
`;

const EventInfo = styled.div`
  position: fixed;
  top: ${(props) => props.top + "px"};
  left: ${(props) => props.left + "px"};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border: solid 2px #ccc;
  background-color: #fff;
  border-radius: 5px;
  padding: 0.3rem 0.5rem;
  margin: 0.5rem;
  z-index: 100;
  > .title {
    color: ${(props) => props.color} !important;
  }
  > .comment {
    color: black !important;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/DayType/CalendarMonth.js